module.exports = __webpack_public_path__ + "img/csr_swiper_02.989a53c7.jpg";